const pillars = [
  {
    icon: 'ri-settings-4-line',
    title: 'Tailored to Your Workflow',
    text: 'Every industry has a unique rhythm. We map automation to how your business actually operates—not a one-size-fits-all template.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Revenue-First Design',
    text: 'Every system we build is optimized for one outcome: more booked jobs and higher close rates at every stage of your pipeline.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Always On, Always Working',
    text: 'Our automation runs 24/7—answering calls, following up leads, and scheduling jobs even when your office is closed.',
  },
];

export default function IndustriesIntro() {
  return (
    <section className="bg-[#F8FAFC] py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <p className="text-slate-500 text-lg leading-relaxed">
            Different industries require fundamentally different automation. An HVAC company
            needs instant call capture and same-day dispatch. A solar company needs
            multi-month lead nurturing and financing follow-up. Omega Solutions AI builds
            systems that are aligned with exactly how each business operates—so automation
            feels natural, not forced.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {pillars.map((p) => (
            <div
              key={p.title}
              className="bg-white rounded-2xl p-8 border border-slate-100 flex flex-col gap-4 hover:border-blue-100 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-xl">
                <i className={`${p.icon} text-blue-600 text-xl`} />
              </div>
              <h3 className="text-[#0F172A] text-lg font-bold">{p.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
